
import base from "./base.service";

const instance = base.service();

export const getAll = () => {
  return instance.get("/statistikaClanka/all");
};

export const deleteStatistikaClanka = (id) => {
  return instance.delete(`/statistikaClanka/${id}`);
};

export const addStatistikaClanka = (novaStatistikaClanka) => {
  return instance.post(`/statistikaClanka`, novaStatistikaClanka);
};

export const getById = (id) => {
  return instance.get(`/statistikaClanka/${id}`);
};

export const getAllByClanakId = (id) => {
  return instance.get(`/statistikaClanka/clanak/${id}`);
};


export const getCountAll = () => {
  return instance.get(`/statistikaClanka/ukupno`);
};

export const getCountByClanakId = (id) => {
  return instance.get(`/statistikaClanka/clanak/${id}/ukupno`);
};


export const getCountByClanakIdAndDateRange = (id, startDate, endDate) => {
  return instance.get(`/statistikaClanka/clanak/${id}/ukupnoUnutarOpsega`, {
    params: { startDate, endDate },
  });
};


export const getByClanakIdAndDateRange = (id, startDate, endDate) => {
  return instance.get(`/statistikaClanka/clanak/${id}/sviUnutarOpsega`, {
    params: { startDate, endDate },
  });
};

export default {
  getAll,
  deleteStatistikaClanka,
  addStatistikaClanka,
  getById,
  getAllByClanakId,
  getCountByClanakId,
  getCountByClanakIdAndDateRange,
  getByClanakIdAndDateRange,
  getCountAll,
};
